const normalizeStrForSearch = (source: string): string => source.trim().toLocaleLowerCase();

export function isContainSubstring(source: string, search: string): boolean {
    return normalizeStrForSearch(source).includes(normalizeStrForSearch(search));
}
